module.exports = wx;